module Eseebase {
    export interface IFilterScope extends ng.IScope {
        onChanged: Function;
        associations: OrganizationalUnitViewModel[];
        departments: OrganizationalUnitViewModel[];
        localizers: string[];
        areas: string[];
        apartmentNumbers: string[];
        changesDone: boolean;
        features: CompanyFeatureList;

        selectors: FilterSelectors;
        buildingPartTypes: string[];
        surfaceMaterials: string[];
        loadingFilters: boolean;
        isExpanded: boolean;

        filter: ModelFilterViewModel;

        tab: string;
        loadSelectors: Function;
        loadTypes: Function;
        apartmentChanged: Function;
        loadOrganizations: Function;
        associationChanged: Function;
        departmentChanged: Function;
        localizerChanged: Function;
        loadFilter: Function;
        save: Function;
        reset: Function;
        openerClick: Function;
        getFromCookies: Function;
        collapseFilter: Function;
        expandFilter: Function;
        tabClicked: Function;
        getDisplayText: Function;
        apartmentLoading: boolean;
        departmentLoading: boolean;
        localizerLoading: boolean;
        localizerSurfaceMaterials: boolean;
        associationLoading: boolean;
    }

    export class FilterDirective {
        public link: (scope: IFilterScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => void;
        public templateUrl = '/app/directives/filter.html';
        public scope = {
            ngModel: '=',
            onChanged: '&'
        };
        public restrict = 'E';
        public require: string;
        public replace: any;

        constructor(private buildingService: BuildingService,
                    private organizationService: OrganizationService,
                    private fileService: FileService,
                    private $q: ng.IQService,
                    private $timeout: ng.ITimeoutService,
                    private $window: ng.IWindowService,
                    private $rootScope: ng.IRootScopeService,
                    private organizationSettingsService: OrganizationSettingsService,
                    private companyService: CompanyService,
                    private textService: TextService
        ) {
            FilterDirective.prototype.replace = 'true';
            FilterDirective.prototype.link = (scope: IFilterScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => {
                window.addEventListener('orientationchange', (evt) => {
                    setTimeout(() => {
                        scope.isExpanded = false;
                        scope.collapseFilter();
                    }, 10);
                });

                element.on('click', (evt: JQueryEventObject) => {
                    evt.stopImmediatePropagation();
                    evt.stopPropagation;
                    evt.cancelBubble = true;
                });

                angular.element('.md-datepicker-calendar').on('click', (evt: JQueryEventObject) => {
                    evt.stopImmediatePropagation();
                    evt.stopPropagation;
                    evt.cancelBubble = true;
                });

                window.addEventListener('click', (evt) => {
                    if (angular.element(evt.target).hasClass('md-scroll-mask')) {
                        return;
                    }
                    setTimeout(() => {
                        scope.isExpanded = false;
                        scope.collapseFilter();
                    }, 10);
                });

                scope.filter = new ModelFilterViewModel();
                scope.getFromCookies = function () {
                    scope.loadingFilters = true;
                    var filters = buildingService.getFilters();
                    return scope.loadFilter(filters).then(
                        $timeout(() =>
                        {
                            scope.loadingFilters = false;
                            scope.changesDone = false;
                        }, 50),
                        () => {
                            scope.loadingFilters = false;
                            scope.changesDone = false;
                        });
                }; 

                organizationSettingsService.getFeatures().then((features: CompanyFeatureList) => {
                    scope.features = features;
                    scope.loadSelectors();
                    scope.loadTypes();
                });

                $rootScope.$on('filter-delete', () => {
                    scope.getFromCookies();
                });

                $rootScope.$on('filter-open', () => {
                    scope.getFromCookies().then(() => {
                        if (!scope.isExpanded) {
                            scope.openerClick();
                        }
                    });
                });

                scope.tab = 'indoor';

                scope.tabClicked = function (tab: string) {
                    scope.tab = tab;
                }

                scope.loadSelectors = function () {
                    scope.selectors = new FilterSelectors();
                    if (!!scope.features && !scope.filter.department.isEmpty() && (scope.features.includeOutdoorData(scope.filter.association.values) || scope.features.includeSimData(scope.filter.association.values))) {
                        buildingService.getSelectors(scope.filter).then((data: FilterSelectors) => {
                            scope.selectors.categories = data.categories;
                            scope.selectors.orientations = data.orientations;
                            scope.selectors.outdoorLevels = data.outdoorLevels;
                            scope.selectors.functions = data.functions;
                            scope.selectors.simLevels = data.simLevels;
                            scope.selectors.keynotes = data.keynotes;
                            scope.selectors.simFamilyTypeNames = data.simFamilyTypeNames;
                        });
                    }
                };

                scope.loadTypes = function () {
                    scope.filter.indoorBuildingPartType = new ModelFilterItemViewModel(true, null);
                    buildingService.getTypes(scope.filter).then((data: string[]) => {
                        scope.buildingPartTypes = HelperService.SortArray(data, null);
                    });
                    if (scope.features != null && scope.filter.association != null && scope.features.includeSurfaceMaterial(scope.filter.association.values)) {
                        scope.localizerSurfaceMaterials = true;
                        scope.filter.surfaceMaterial = new ModelFilterItemViewModel(false, null);
                        buildingService.getSurfaceMaterials(scope.filter).then((data: string[]) => {
                            scope.surfaceMaterials = HelperService.SortArray(data, null);
                            scope.localizerSurfaceMaterials = false;
                        }, () => { scope.localizerSurfaceMaterials = false; });
                    }
                };

                scope.loadOrganizations = function () {
                    scope.loadingFilters = true;
                    scope.associationLoading = true;
                    organizationService.list().then((response: OrganizationalUnitViewModel[]) => {
                        scope.associationLoading = false;
                        scope.associations = response;
                        var filters = buildingService.getFilters();
                        scope.loadFilter(filters).then(() => {
                            $timeout(() => {
                                scope.loadingFilters = false;
                                scope.changesDone = false;
                                if (response != null && response.length == 1) {
                                    scope.filter.association.values = [response[0].id];

                                    scope.departments = response[0].children;
                                    if (scope.departments != null && scope.departments.length == 1) {
                                        scope.filter.department.values = [scope.departments[0].id];
                                        scope.departmentChanged();
                                    }
                                }
                            }, 10);
                        }, () => { scope.loadingFilters = false; scope.changesDone = false; });
                    }, () => { scope.loadingFilters = false; scope.changesDone = false; });
                };

                scope.associationChanged = function () {
                    //if (!scope.changesDone) {
                    //    return;
                    //}
                    //scope.changesDone = false;
                    if (scope.loadingFilters) {
                        return;
                    }
                    scope.filter.department.values = [];
                    scope.filter.localizer.values = [];
                    scope.filter.apartment.values = [];
                    scope.filter.simArea.values = [];

                    scope.departments = [];
                    scope.localizers = [];
                    scope.apartmentNumbers = [];
                    scope.areas = [];

                    if (scope.associations != null && scope.filter.association.any()) {
                        for (var i = 0; i < scope.filter.association.values.length; i++) {
                            var association = scope.associations.filter(a => a.id == scope.filter.association.values[i]);
                            if (association.length > 0) {
                                scope.departments = scope.departments.concat(association[0].children);
                            }
                        }
                        if (scope.departments != null && scope.departments.length == 1) {
                            scope.filter.department.values = [scope.departments[0].id];
                            scope.departmentChanged();
                        }
                    }
                    scope.loadTypes();
                }

                scope.apartmentChanged = function () {
                    scope.loadTypes();
                }

                scope.departmentChanged = function () {
                    if (scope.loadingFilters) {
                        return;
                    }
                    scope.filter.localizer.values = [];
                    scope.filter.apartment.values = [];
                    scope.filter.simArea.values = [];
                    scope.localizers = [];
                    scope.areas = [];
                    scope.apartmentNumbers = [];
                    if (scope.filter.department.any() || (scope.departments != null && scope.departments.length == 1)) {
                        scope.localizerLoading = true;
                        fileService.getLocalizers(scope.filter).then((localizers: any) => {
                            scope.localizers = HelperService.SortArray(localizers.localizers, null);
                            scope.areas = localizers.areas;
                            //if (scope.localizers != null && scope.localizers.length == 1) {
                            //    scope.filter.localizer.values = [scope.localizers[0]];
                            //}
                            //if (scope.areas != null && scope.areas.length == 1) {
                            //    scope.filter.simArea.values = [scope.areas[0]];
                            //}
                            scope.localizerLoading = false;
                        }, () => { scope.localizerLoading = false;});
                        scope.apartmentLoading = true;
                        fileService.getApartments(scope.filter).then((apartments: string[]) => {
                            scope.apartmentNumbers = HelperService.SortArray(apartments, null);
                            if (scope.apartmentNumbers.length == 1) {
                                scope.filter.apartment.values = [scope.apartmentNumbers[0]];
                            }
                            if (scope.apartmentNumbers != null && scope.apartmentNumbers.length == 1) {
                                scope.filter.apartment.values = [scope.apartmentNumbers[0]];
                            }
                            scope.apartmentLoading = false;
                        }, () => {
                            scope.apartmentLoading = false;
                        });
                    }
                    scope.loadSelectors();
                    scope.loadTypes();
                }

                scope.getDisplayText = function (model: any[], collection: any[], emptyText: string, template: string) {
                    if (model == null || model.length == 0) {
                        return emptyText;
                    }
                    if (model != null && model.length == 1 && collection != null && collection.length > 0) {
                        if (typeof (model[0]) === 'string' && typeof (collection[0]) === 'string') {
                            return textService.translate(collection.filter(m => m == model[0])[0]);
                        }
                        else if (typeof (model[0]) === 'string' && typeof (collection[0]) != 'string') {
                            return textService.translate(collection.filter(m => m.id == model[0])[0].name);
                        }
                        else {
                            return textService.translate(collection.filter(m => m.id == model[0].id)[0].name);
                        }
                    }
                    if (model != null && model.length > 1) {
                        return template.replace(/\{0\}/g, model.length.toString());
                    }
                }

                scope.localizerChanged = function () {
                    if (!scope.changesDone || scope.localizers == null || scope.localizers.length < 2) {
                        return;
                    }
                    scope.changesDone = false;
                    if (scope.loadingFilters) {
                        return;
                    }
                    scope.filter.apartment.values = [];
                    scope.apartmentNumbers = [];
                    scope.apartmentLoading = true;
                    fileService.getApartments(scope.filter).then((apartments: string[]) => {
                        scope.apartmentNumbers = HelperService.SortArray(apartments, null);
                        scope.apartmentLoading = false;
                    }, () => { scope.apartmentLoading = false; });
                    scope.loadTypes();
                }

                scope.loadFilter = function (filters: ModelFilterViewModel) {
                    scope.filter = new ModelFilterViewModel();
                    var def = $q.defer();
                    scope.departments = [];
                    scope.localizers = [];
                    scope.areas = [];
                    scope.apartmentNumbers = [];
                    if (filters != null) {
                        scope.filter = filters;

                        if (scope.filter.association.any()) {
                            for (var i = 0; i < scope.associations.length; i++) {
                                var association = scope.associations.filter(a => a.id == scope.filter.association.values[i]);
                                if (association != null && association.length > 0) {
                                    scope.departments = scope.departments.concat(association[0].children);
                                }
                            }
                        }

                        if (scope.associations != null && scope.associations.length == 1) {
                            scope.departments = scope.associations[0].children;
                        }

                        if (scope.filter.department.any() || (scope.departments != null && scope.departments.length == 1)) {
                            scope.loadSelectors();
                            fileService.getLocalizers(scope.filter).then((localizers: any) => {
                                scope.localizers = HelperService.SortArray(localizers.localizers, null);
                                scope.areas = localizers.areas;
                                def.resolve();
                            }, () => def.reject());

                            fileService.getApartments(scope.filter).then((apartments: string[]) => {
                                scope.apartmentNumbers = HelperService.SortArray(apartments, null);
                                def.resolve();
                            }, () => def.reject());
                        }
                        else {
                            def.resolve();
                        }
                    }
                    return def.promise;
                }

                scope.save = function () {
                    buildingService.saveFilters(scope.filter);
                    $rootScope.$broadcast('filter-change');
                    scope.openerClick();
                }

                scope.reset = function () {
                    var filterModel = new ModelFilterViewModel();
                    buildingService.saveFilters(filterModel);
                    scope.loadFilter(filterModel);
                }

                scope.openerClick = function () {
                    scope.isExpanded = !scope.isExpanded;
                    if (scope.isExpanded) {
                        scope.getFromCookies();
                        scope.expandFilter();
                    }
                    else {
                        scope.collapseFilter();
                    }
                }

                scope.expandFilter = function () {
                    element.css('left', '0px');
                    element.addClass('active');
                    if (element.width() == angular.element('md-content').width()) {
                        element.find('.opener i').addClass('icon-close');
                        element.find('.opener i').removeClass('icon-change');
                    }
                }

                scope.collapseFilter = function () {
                    var left = -1 * FilterDirective.getFullWidth(element.find('.filter-container'));
                    element.css('left', left + 'px');
                    element.removeClass('active');
                    if (element.width() == angular.element('md-content').width()) {
                        element.find('.opener i').removeClass('icon-close');
                        element.find('.opener i').addClass('icon-change');
                    }
                }
                scope.loadOrganizations();
                element.css('left', -FilterDirective.getFullWidth(element.find('.filter-container')) + 'px');
            };
        }

        private static getFullWidth(element: ng.IAugmentedJQuery) {
            var margin = parseFloat(element.css('margin-left')) + parseFloat(element.css('margin-right'));
            var border = parseFloat(element.css('border-left-width')) + parseFloat(element.css('border-right-width'));
            return element.width() + margin + border + 1;
        }

        public static Factory() {
            var directive = (buildingService: BuildingService, organizationService: OrganizationService, fileService: FileService, $q: ng.IQService, $timeout: ng.ITimeoutService, $window: ng.IWindowService, $rootScope: ng.IRootScopeService, organizationSettingsService: OrganizationSettingsService, companyService: CompanyService, textService: TextService) => {
                return new FilterDirective(buildingService, organizationService, fileService, $q, $timeout, $window, $rootScope, organizationSettingsService, companyService, textService);
            };

            directive['$inject'] = ['BuildingService', 'OrganizationService', 'FileService', '$q', '$timeout', '$window', '$rootScope', 'OrganizationSettingsService', 'CompanyService', 'TextService'];

            return directive;
        }
    }

    angular
        .module('eseebase')
        .directive('filterPage', FilterDirective.Factory());
}